import React, { useState, useEffect } from "react";
import { EpreuvesList2 } from "./EpreuvesList2";
import { loadEpreuves } from "./requests";
import checkboxesFormat from "./Data/TriathlonSizeData";
import Select from "react-select";
import MapLocation from "./Components/MapLocate";
import makeAnimated from "react-select/animated";
import ProfileSelector from "./Components/ProfileSelector";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import SearchIcon from "@material-ui/icons/Search";
import Loader from "./medias/loader.gif";

const currentYear = new Date().getFullYear();
console.log("currentYear", currentYear);
const animatedComponents = makeAnimated();

export const EpreuveBoard = () => {
  // persistent values of search engine
  const yearLocalStorage = window.localStorage.getItem("year")
    ? Number(window.localStorage.getItem("year"))
    : currentYear;
  const monthLocalStorage = window.localStorage.getItem("month")
    ? Number(window.localStorage.getItem("month"))
    : 0;
  const regionLocalStorage = window.localStorage.getItem("region")
    ? window.localStorage.getItem("region")
    : "Toute la France";

  // different filter variables
  const [epreuves, setEpreuves] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState({
    value: regionLocalStorage,
    label: regionLocalStorage.toString(),
  });
  const [nameEvent, setNameEvent] = useState("");
  const [yearSelected, setYearSelected] = useState({
    value: yearLocalStorage,
    label: yearLocalStorage ? yearLocalStorage.toString() : { currentYear },
  });
  const [monthSelected, setMonthSelected] = useState({
    value: monthLocalStorage ? monthLocalStorage : 0,
    label: monthActive[monthLocalStorage].label,
  });
  const [formatToCheck, setFormatToCheck] = useState(checkboxesFormat);
  const [checkedItems, setCheckedItems] = useState({
    Jeunes: true,
    XXS: true,
    XS: true,
    S: true,
    M: true,
    L: true,
    XL: true,
    XXL: true,
  });
  const [loader, setLoader] = useState(false);
  //system reload map
  const [childKey, setChildKey] = useState(0);
  const reloadChild = () => {
    // Incrementing the key will force the child component to reload
    setChildKey((prevKey) => prevKey + 1);
  };
  // change state of search variables
  const handleChange = (event) => {
    // updating an object instead of a Map
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };
  // region
  const handleRegion = (selectedRegion) => {
    setSelectedRegion(selectedRegion);
  };
  // Month
  const handleMonth = (monthSelected) => {
    setMonthSelected(monthSelected);
  };
  // Year
  const handleYear = (yearSelected) => {
    setYearSelected(yearSelected);
    reloadChild();
  };
  // Size format
  const handleFormat = (e) => {
    setFormatToCheck(e);
  };
  // search engine
  const handleSearch = (event) => {
    setNameEvent(event.target.value);
  };
  // reset selected options
  const removeFilters = () => {
    setSelectedRegion({ value: "Toute la France", label: "Toute la France" });
    setNameEvent("");
    setMonthSelected({ value: 0, label: "Toute l'année" });
    window.localStorage.clear();
  };

  // const fetchData = async () => {
  //   setLoader(true);
  //   let region = "";
  //   let city = nameEvent;
  //   const selectedValue = [true];
  //   const formatHasSelected = Object.keys(checkedItems).reduce(function (r, e) {
  //     if (selectedValue.includes(checkedItems[e])) r[e] = checkedItems[e];
  //     return r;
  //   }, {});
  //   let formats = Object.keys(formatHasSelected);

  //   selectedRegion.value === "Toute la France"
  //     ? (region = "")
  //     : (region = selectedRegion.value);

  //   try {
  //     const epreuvesResult = await loadEpreuves(
  //       region,
  //       nameEvent,
  //       city,
  //       monthSelected["value"],
  //       yearSelected["value"],
  //       formats,
  //       "",
  //       0,
  //       25000,
  //       ["Piscine", "Lac", "Mer", "Rivière", "Plan d'eau", "0"],
  //       ["1", "0"]
  //     );
  //     console.log("data", epreuvesResult);
  //     setEpreuves(epreuvesResult);
  //     setLoader(false);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchData = async () => {
    setLoader(true);
    let region = "";
    const selectedValue = [true];
    const formatHasSelected = Object.keys(checkedItems).reduce(function (r, e) {
      if (selectedValue.includes(checkedItems[e])) r[e] = checkedItems[e];
      return r;
    }, {});
    let formats = Object.keys(formatHasSelected);

    selectedRegion.value === "Toute la France"
      ? (region = "")
      : (region = selectedRegion.value);

    try {
      const epreuvesResult = await loadEpreuves(
        region,
        nameEvent,
        monthSelected["value"],
        yearSelected["value"],
        formats,
        "",
        0,
        25000,
        ["Piscine", "Lac", "Mer", "Rivière", "Plan d'eau", "0"],
        ["1", "0"]
      );
      setEpreuves(epreuvesResult);
    } catch (error) {
      console.log(error);
    } finally {
    setLoader(false);
  }
  };

  useEffect(() => {
    window.localStorage.setItem("year", yearSelected.value);
  }, [yearSelected]);
  useEffect(() => {
    window.localStorage.setItem("month", monthSelected.value);
  }, [monthSelected]);
  useEffect(() => {
    window.localStorage.setItem("region", selectedRegion.value);
  }, [selectedRegion]);

  useEffect(() => {
    fetchData();
  }, [
    selectedRegion,
    nameEvent,
    monthSelected,
    yearSelected,
    formatToCheck,
    checkedItems,
  ]);

  return (
    <div className="container my-2 visible-md">
      <ProfileSelector />
      {/* Only for smartphone : search engine */}
      <div className="col-md-6 p-0 input-group my-3">
        <span
          className="input-group-text"
          id="Search triathlon"
          style={{
            borderRadius: "0px",
            height: "38px",
          }}
        >
          <SearchIcon alt="Rechercher une épreuve" />
        </span>
        <div className="input-group-prepend"></div>
        <input
          type="text"
          className="form-control"
          id="Search triathlon"
          aria-describedby="search triathlon by name"
          onChange={handleSearch}
          value={nameEvent}
          placeholder="Rechercher une épreuve"
          style={{ height: "38px" }}
        />
        <span
          className="btn btn-warning ml-2 btn-sm"
          onClick={removeFilters}
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <CancelPresentationIcon
            alt="Effacer la recherche"
            className="py-auto "
          />
        </span>
      </div>

      {/* left column */}
      <div className="row">
        <div className="col-lg-8">
          <div className="row mb-3">
            <h1 className="title">
              Calendrier des triathlons {loader ? null : yearSelected.value} en
              France
            </h1>
          </div>
          <div className="row my-2 font-weight-bold">
            <h6 className="font-weight-bold text-warning">
              {epreuves.length} épreuves (
              {selectedRegion.value +
                " - " +
                monthSelected.label +
                " " +
                yearSelected.value}
              )
            </h6>
          </div>
          {loader ? (
            <img
              src={Loader}
              alt="Chargement des résultats..."
              className="mx-auto d-block"
            />
          ) : (
            <EpreuvesList2
              epreuves={epreuves}
              remove={true}
              filterByRegion={selectedRegion ? selectedRegion.value : ""}
            />
          )}
        </div>
        {/* Right column */}

        <div className="col-lg-4">
          <div className=" ml-md-2">
            <div className="col-lg-12 font-weight-bold mb-2 ">
              <h3 className="font-weight-bold">Vos critères de recherche</h3>

              <div
                className="col-lg-12 p-0 mb-2"
                style={{ position: "relative", zIndex: "2" }}
              >
                <Select
                  defaultValue={selectedRegion}
                  components={animatedComponents}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  onChange={handleRegion}
                  options={options2}
                  value={selectedRegion}
                  placeholder="Toute la France"
                />
              </div>
              <div className="row">
                <div
                  className="col-lg-6 p-0 ml-md-3 mb-2"
                  style={{ position: "relative", zIndex: "2" }}
                >
                  <Select
                    defaultValue={0}
                    onChange={handleMonth}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={monthActive}
                    value={monthSelected}
                    placeholder="Choisir un mois"
                  />
                </div>
                <div className="col-lg-5 p-0 ml-md-1 mb-2">
                  <Select
                    defaultValue={yearSelected}
                    onChange={handleYear}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={yearActive}
                    value={yearSelected}
                    placeholder={currentYear}
                  />
                </div>
              </div>
              <div className="row">
                <div
                  className="col-lg-12 p-0 ml-3 mb-2 accentColor-primary"
                  style={{ position: "relative", zIndex: "2" }}
                >
                  <label className="border-bottom border-primary">
                    Sélectionner le format&nbsp;: {checkedItems["check-box-1"]}{" "}
                  </label>{" "}
                  <br />
                  {checkboxes.map((item) => (
                    <label key={item.key} className="mr-2">
                      {item.name}
                      <input
                        type="checkbox"
                        className="ml-2"
                        name={item.name}
                        checked={checkedItems[item.name]}
                        onChange={handleChange}
                      />
                    </label>
                  ))}
                </div>
              </div>
              {/* Map */}
              <div className="mt-1">
                <h4 className="text-warning">
                  Trouver votre triathlon sur la carte
                </h4>
                {console.log("key", yearSelected)}

                <MapLocation
                  zoomSize="5"
                  region={selectedRegion}
                  epreuves={epreuves}
                  yearSelected={yearSelected}
                  key={childKey}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const checkboxes = [
  {
    key: 0,
    name: "Jeunes",
    label: "Jeunes",
  },
  {
    key: 1,
    name: "XXS",
    label: "XXS",
  },
  {
    key: 2,
    name: "XS",
    label: "XS",
  },
  {
    key: 3,
    name: "S",
    label: "S",
  },
  {
    key: 4,
    name: "M",
    label: "M",
  },
  {
    key: 5,
    name: "L",
    label: "L",
  },
  {
    key: 6,
    name: "XL",
    label: "XL",
  },
  {
    key: 7,
    name: "XXL",
    check: "XXL",
  },
];

const yearActive = [
  { value: 2022, label: "2022" },
  { value: 2023, label: "2023" },
  { value: 2024, label: "2024" },
  { value: 2025, label: "2025" },
  { value: 2026, label: "2026" },
];

const monthActive = [
  { value: 0, label: "Toute l'année" },
  { value: 1, label: "Janvier" },
  { value: 2, label: "Février" },
  { value: 3, label: "Mars" },
  { value: 4, label: "Avril" },
  { value: 5, label: "Mai" },
  { value: 6, label: "Juin" },
  { value: 7, label: "Juillet" },
  { value: 8, label: "Août" },
  { value: 9, label: "Septembre" },
  { value: 10, label: "Octobre" },
  { value: 11, label: "Novembre" },
  { value: 12, label: "Décembre" },
];

const options2 = [
  { value: "Toute la France", label: "Toute la France" },
  { value: "Alsace", label: "Alsace" },
  { value: "Aquitaine", label: "Aquitaine" },
  { value: "Auvergne", label: "Auvergne" },
  { value: "Bretagne", label: "Bretagne" },
  { value: "Bourgogne", label: "Bourgogne" },
  { value: "Champagne-Ardenne", label: "Champagne-Ardenne" },
  { value: "Centre", label: "Centre" },
  { value: "Corse", label: "Corse" },
  { value: "Franche-Comté", label: "Franche-Comté" },
  { value: "Guadeloupe", label: "Guadeloupe" },
  { value: "Guyane", label: "Guyane" },
  { value: "Ile-de-France", label: "Ile-de-France" },
  { value: "Languedoc-Roussillon", label: "Languedoc-Roussillon" },
  { value: "La-Réunion", label: "La-Réunion" },
  { value: "Limousin", label: "Limousin" },
  { value: "Lorraine", label: "Lorraine" },
  { value: "Mayotte", label: "Mayotte" },
  { value: "Martinique", label: "Martinique" },
  { value: "Midi-Pyrénées", label: "Midi-Pyrénées" },
  { value: "Nord-Pas-de-Calais", label: "Nord-Pas-de-Calais" },
  { value: "Normandie", label: "Normandie" },
    { value: "Nouvelle-Calédonie", label: "Nouvelle-Calédonie" },
  { value: "Pays-de-la-Loire", label: "Pays-de-la-Loire" },
  { value: "Picardie", label: "Picardie" },
  { value: "Poitou-Charentes", label: "Poitou-Charentes" },
  { value: "Provence-Alpes-Côte-d'Azur", label: "Provence-Alpes-Côte-d'Azur" },
  { value: "Rhône-Alpes", label: "Rhône-Alpes" },
];

// const checkboxesFormat = [
//   {
//     key: 0,
//     value: "Jeunes",
//     check: true,
//   },
//   {
//     key: 1,
//     value: "XS",
//     check: true,
//   },
//   {
//     key: 2,
//     value: "S",
//     check: true,
//   },
//   {
//     key: 3,
//     value: "M",
//     check: true,
//   },
//   {
//     key: 4,
//     value: "L",
//     check: true,
//   },
//   {
//     key: 5,
//     value: "XL",

//     check: true,
//   },
//   {
//     key: 6,
//     value: "XXL",
//     check: true,
//   },
// ];

const newRegion = [
  { value: "Toute la France", label: "Toute la France" },
  { value: "Auvergne-Rhône-Alpes", label: "Auvergne-Rhône-Alpes" },
  { value: "Bourgogne-Franche-Comté", label: "Bourgogne-Franche-Comté" },
  { value: "Bretagne", label: "Bretagne" },
  { value: "Centre-Val-de-Loire", label: "Centre-Val-de-Loire" },
  { value: "Corse", label: "Corse" },
  { value: "Grand-Est", label: "Grand-Est" },
  { value: "Guadeloupe", label: "Guadeloupe" },
  { value: "Guyane", label: "Guyane" },
  { value: "Hauts-de-France", label: "Hauts-de-France" },
  { value: "Ile-de-France", label: "Ile-de-France" },
  { value: "La-Réunion", label: "La-Réunion" },
  { value: "Martinique", label: "Martinique" },
  { value: "Mayotte", label: "Mayotte" },
  { value: "Normandie", label: "Normandie" },
  { value: "Nouvelle-Aquitaine", label: "Nouvelle-Aquitaine" },
  { value: "Nouvelle-Calédonie", label: "Nouvelle-Calédonie" },
  { value: "Occitanie", label: "Occitanie" },
  { value: "Pays-de-la-Loire", label: "Pays-de-la-Loire" },
  { value: "Provence-Alpes-Côte-d'Azur", label: "Provence-Alpes-Côte-d'Azur" },
];



// import React, { useState, useEffect } from "react";
// import { EpreuvesList2 } from "./EpreuvesList2";
// import { loadEpreuves } from "./requests";
// import checkboxesFormat from "./Data/TriathlonSizeData";
// import Select from "react-select";
// import MapLocation from "./Components/MapLocate";
// import makeAnimated from "react-select/animated";
// import ProfileSelector from "./Components/ProfileSelector";
// import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
// import SearchIcon from "@material-ui/icons/Search";

// const animatedComponents = makeAnimated();

// export const EpreuveBoard = () => {
//   // persistent values of search engine
//   const yearLocalStorage = window.localStorage.getItem("year")
//     ? Number(window.localStorage.getItem("year"))
//     : 2026;
//   const monthLocalStorage = window.localStorage.getItem("month")
//     ? Number(window.localStorage.getItem("month"))
//     : 0;
//   const regionLocalStorage = window.localStorage.getItem("region")
//     ? window.localStorage.getItem("region")
//     : "Toute la France";

//   // different filter variables
//   const [epreuves, setEpreuves] = useState([]);
//   const [selectedRegion, setSelectedRegion] = useState({
//     value: regionLocalStorage,
//     label: regionLocalStorage.toString(),
//   });
//   const [nameEvent, setNameEvent] = useState("");
//   const [yearSelected, setYearSelected] = useState({
//     value: yearLocalStorage,
//     label: yearLocalStorage ? yearLocalStorage.toString() : "2023",
//   });
//   const [monthSelected, setMonthSelected] = useState({
//     value: monthLocalStorage ? monthLocalStorage : 0,
//     label: monthActive[monthLocalStorage].label,
//   });
//   const [formatToCheck, setFormatToCheck] = useState(checkboxesFormat);
//   const [checkedItems, setCheckedItems] = useState({
//     Jeunes: true,
//     XXS: true,
//     XS: true,
//     S: true,
//     M: true,
//     L: true,
//     XL: true,
//     XXL: true,
//   });
//   //system reload map
//   const [childKey, setChildKey] = useState(0);
//   const reloadChild = () => {
//     // Incrementing the key will force the child component to reload
//     setChildKey((prevKey) => prevKey + 1);
//   };
//   // change state of search variables
//   const handleChange = (event) => {
//     // updating an object instead of a Map
//     setCheckedItems({
//       ...checkedItems,
//       [event.target.name]: event.target.checked,
//     });
//   };
//   // region
//   const handleRegion = (selectedRegion) => {
//     setSelectedRegion(selectedRegion);
//   };
//   // Month
//   const handleMonth = (monthSelected) => {
//     setMonthSelected(monthSelected);
//   };
//   // Year
//   const handleYear = (yearSelected) => {
//     setYearSelected(yearSelected);
//     reloadChild();
//   };
//   // Size format
//   const handleFormat = (e) => {
//     setFormatToCheck(e);
//   };
//   // search engine
//   const handleSearch = (event) => {
//     setNameEvent(event.target.value);
//   };
//   // reset selected options
//   const removeFilters = () => {
//     setSelectedRegion({ value: "Toute la France", label: "Toute la France" });
//     setNameEvent("");
//     setMonthSelected({ value: 0, label: "Toute l'année" });
//     window.localStorage.clear();
//   };

//   const fetchData = async () => {
//     let region = "";
//     const selectedValue = [true];
//     const formatHasSelected = Object.keys(checkedItems).reduce(function (r, e) {
//       if (selectedValue.includes(checkedItems[e])) r[e] = checkedItems[e];
//       return r;
//     }, {});
//     let formats = Object.keys(formatHasSelected);

//     selectedRegion.value === "Toute la France"
//       ? (region = "")
//       : (region = selectedRegion.value);

//     try {
//       const epreuvesResult = await loadEpreuves(
//         region,
//         nameEvent,
//         monthSelected["value"],
//         yearSelected["value"],
//         formats,
//         "",
//         0,
//         25000,
//         ["Piscine", "Lac", "Mer", "Rivière", "Plan d'eau", "0"],
//         ["1", "0"]
//       );
//       setEpreuves(epreuvesResult);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     window.localStorage.setItem("year", yearSelected.value);
//   }, [yearSelected]);
//   useEffect(() => {
//     window.localStorage.setItem("month", monthSelected.value);
//   }, [monthSelected]);
//   useEffect(() => {
//     window.localStorage.setItem("region", selectedRegion.value);
//   }, [selectedRegion]);

//   useEffect(() => {
//     // surtout ne pas faire passer les valeurs en paramètre !
//     fetchData();
//   }, [
//     selectedRegion,
//     nameEvent,
//     monthSelected,
//     yearSelected,
//     formatToCheck,
//     checkedItems,
//   ]);

//   return (
//     <div className="container my-2 visible-md">
//       <ProfileSelector />
//       {/* Only for smartphone : search engine */}
//       <div className="col-md-6 p-0 input-group my-3">
//         <span
//           className="input-group-text"
//           id="Search triathlon"
//           style={{
//             borderRadius: "0px",
//             height: "38px",
//           }}
//         >
//           <SearchIcon alt="Rechercher une épreuve" />
//         </span>
//         <div className="input-group-prepend"></div>
//         <input
//           type="text"
//           className="form-control"
//           id="Search triathlon"
//           aria-describedby="search triathlon by name"
//           onChange={handleSearch}
//           value={nameEvent}
//           placeholder="Rechercher une épreuve"
//           style={{ height: "38px" }}
//         />
//         <span
//           className="btn btn-warning ml-2 btn-sm"
//           onClick={removeFilters}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             flexWrap: "wrap",
//           }}
//         >
//           <CancelPresentationIcon
//             alt="Effacer la recherche"
//             className="py-auto "
//           />
//         </span>
//       </div>

//       {/* left column */}
//       <div className="row">
//         <div className="col-lg-8">
//           <div className="row mb-3">
//             <h1 className="title">
//               Calendrier des triathlons {yearSelected.value} en France
//             </h1>
//           </div>
//           <div className="row my-2 font-weight-bold">
//             <h6 className="font-weight-bold text-warning">
//               {epreuves.length} épreuves (
//               {selectedRegion.value +
//                 " - " +
//                 monthSelected.label +
//                 " " +
//                 yearSelected.value}
//               )
//             </h6>
//           </div>
//           <EpreuvesList2
//             epreuves={epreuves}
//             remove={true}
//             filterByRegion={selectedRegion ? selectedRegion.value : ""}
//           />
//         </div>
//         {/* Right column */}

//         <div className="col-lg-4">
//           <div className=" ml-md-2">
//             <div className="col-lg-12 font-weight-bold mb-2 ">
//               <h3 className="font-weight-bold">Vos critères de recherche</h3>

//               <div
//                 className="col-lg-12 p-0 mb-2"
//                 style={{ position: "relative", zIndex: "2" }}
//               >
//                 <Select
//                   defaultValue={selectedRegion}
//                   components={animatedComponents}
//                   menuPortalTarget={document.body}
//                   styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
//                   onChange={handleRegion}
//                   options={options2}
//                   value={selectedRegion}
//                   placeholder="Toute la France"
//                 />
//               </div>
//               <div className="row">
//                 <div
//                   className="col-lg-6 p-0 ml-md-3 mb-2"
//                   style={{ position: "relative", zIndex: "2" }}
//                 >
//                   <Select
//                     defaultValue={0}
//                     onChange={handleMonth}
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                     }}
//                     options={monthActive}
//                     value={monthSelected}
//                     placeholder="Choisir un mois"
//                   />
//                 </div>
//                 <div className="col-lg-5 p-0 ml-md-1 mb-2">
//                   <Select
//                     defaultValue={yearSelected}
//                     onChange={handleYear}
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                     }}
//                     options={yearActive}
//                     value={yearSelected}
//                     placeholder="2023"
//                   />
//                 </div>
//               </div>
//               <div className="row">
//                 <div
//                   className="col-lg-12 p-0 ml-3 mb-2 accentColor-primary"
//                   style={{ position: "relative", zIndex: "2" }}
//                 >
//                   <label className="border-bottom border-primary">
//                     Sélectionner le format&nbsp;: {checkedItems["check-box-1"]}{" "}
//                   </label>{" "}
//                   <br />
//                   {checkboxes.map((item) => (
//                     <label key={item.key} className="mr-2">
//                       {item.name}
//                       <input
//                         type="checkbox"
//                         className="ml-2"
//                         name={item.name}
//                         checked={checkedItems[item.name]}
//                         onChange={handleChange}
//                       />
//                     </label>
//                   ))}
//                 </div>
//               </div>
//               {/* Map */}
//               <div className="mt-1">
//                 <h4 className="text-warning">
//                   Trouver votre triathlon sur la carte
//                 </h4>
//                 {console.log("key", yearSelected)}

//                 <MapLocation
//                   zoomSize="5"
//                   region={selectedRegion}
//                   epreuves={epreuves}
//                   yearSelected={yearSelected}
//                   key={childKey}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const checkboxes = [
//   {
//     key: 0,
//     name: "Jeunes",
//     label: "Jeunes",
//   },
//   {
//     key: 1,
//     name: "XXS",
//     label: "XXS",
//   },
//   {
//     key: 2,
//     name: "XS",
//     label: "XS",
//   },
//   {
//     key: 3,
//     name: "S",
//     label: "S",
//   },
//   {
//     key: 4,
//     name: "M",
//     label: "M",
//   },
//   {
//     key: 5,
//     name: "L",
//     label: "L",
//   },
//   {
//     key: 6,
//     name: "XL",
//     label: "XL",
//   },
//   {
//     key: 7,
//     name: "XXL",
//     check: "XXL",
//   },
// ];

// const yearActive = [
//   { value: 2022, label: "2022" },
//   { value: 2023, label: "2023" },
//   { value: 2024, label: "2024" },
//   { value: 2025, label: "2025" },
//   { value: 2026, label: "2026" },
// ];

// const monthActive = [
//   { value: 0, label: "Toute l'année" },
//   { value: 1, label: "Janvier" },
//   { value: 2, label: "Février" },
//   { value: 3, label: "Mars" },
//   { value: 4, label: "Avril" },
//   { value: 5, label: "Mai" },
//   { value: 6, label: "Juin" },
//   { value: 7, label: "Juillet" },
//   { value: 8, label: "Août" },
//   { value: 9, label: "Septembre" },
//   { value: 10, label: "Octobre" },
//   { value: 11, label: "Novembre" },
//   { value: 12, label: "Décembre" },
// ];

// const options2 = [
//   { value: "Toute la France", label: "Toute la France" },
//   { value: "Alsace", label: "Alsace" },
//   { value: "Aquitaine", label: "Aquitaine" },
//   { value: "Auvergne", label: "Auvergne" },
//   { value: "Bretagne", label: "Bretagne" },
//   { value: "Bourgogne", label: "Bourgogne" },
//   { value: "Centre", label: "Centre" },
//   { value: "Corse", label: "Corse" },
//   { value: "Franche-Comté", label: "Franche-Comté" },
//   { value: "Guadeloupe", label: "Guadeloupe" },
//   { value: "Guyane", label: "Guyane" },
//   { value: "Ile-de-France", label: "Ile-de-France" },
//   { value: "Languedoc-Roussillon", label: "Languedoc-Roussillon" },
//   { value: "La-Réunion", label: "La-Réunion" },
//   { value: "Limousin", label: "Limousin" },
//   { value: "Lorraine", label: "Lorraine" },
//   { value: "Mayotte", label: "Mayotte" },
//   { value: "Martinique", label: "Martinique" },
//   { value: "Midi-Pyrénées", label: "Midi-Pyrénées" },
//   { value: "Nord-Pas-de-Calais", label: "Nord-Pas-de-Calais" },
//   { value: "Normandie", label: "Normandie" },
//   { value: "Pays-de-la-Loire", label: "Pays-de-la-Loire" },
//   { value: "Picardie", label: "Picardie" },
//   { value: "Poitou-Charentes", label: "Poitou-Charentes" },
//   { value: "Provence-Alpes-Côte-d'Azur", label: "Provence-Alpes-Côte-d'Azur" },
//   { value: "Rhône-Alpes", label: "Rhône-Alpes" },
// ];

// // const checkboxesFormat = [
// //   {
// //     key: 0,
// //     value: "Jeunes",
// //     check: true,
// //   },
// //   {
// //     key: 1,
// //     value: "XS",
// //     check: true,
// //   },
// //   {
// //     key: 2,
// //     value: "S",
// //     check: true,
// //   },
// //   {
// //     key: 3,
// //     value: "M",
// //     check: true,
// //   },
// //   {
// //     key: 4,
// //     value: "L",
// //     check: true,
// //   },
// //   {
// //     key: 5,
// //     value: "XL",

// //     check: true,
// //   },
// //   {
// //     key: 6,
// //     value: "XXL",
// //     check: true,
// //   },
// // ];

// const newRegion = [
//   { value: "Toute la France", label: "Toute la France" },
//   { value: "Auvergne-Rhône-Alpes", label: "Auvergne-Rhône-Alpes" },
//   { value: "Bourgogne-Franche-Comté", label: "Bourgogne-Franche-Comté" },
//   { value: "Bretagne", label: "Bretagne" },
//   { value: "Centre-Val-de-Loire", label: "Centre-Val-de-Loire" },
//   { value: "Corse", label: "Corse" },
//   { value: "Grand-Est", label: "Grand-Est" },
//   { value: "Guadeloupe", label: "Guadeloupe" },
//   { value: "Guyane", label: "Guyane" },
//   { value: "Hauts-de-France", label: "Hauts-de-France" },
//   { value: "Ile-de-France", label: "Ile-de-France" },
//   { value: "La-Réunion", label: "La-Réunion" },
//   { value: "Martinique", label: "Martinique" },
//   { value: "Mayotte", label: "Mayotte" },
//   { value: "Normandie", label: "Normandie" },
//   { value: "Nouvelle-Aquitaine", label: "Nouvelle-Aquitaine" },
//   { value: "Occitanie", label: "Occitanie" },
//   { value: "Pays-de-la-Loire", label: "Pays-de-la-Loire" },
//   { value: "Provence-Alpes-Côte-d'Azur", label: "Provence-Alpes-Côte-d'Azur" },
// ];
